import gql from 'graphql-tag';

export type AcceptTicketMutationVars = { token: string; email: string };

export const ACCEPT_TICKET_MUTATION = gql`
  mutation accept($token: String, $email: String) {
    viewer(token: $token) {
      acceptedTicketAccessKey: acceptTicket(email: $email)
    }
  }
`;

export const GET_TICKETS_QUERY = gql`
  query getTickets($token: String!, $ticketKey: String!) {
    viewer(token: $token) {
      getTickets(ticketKey: $ticketKey) {
        items {
          id
          globalId
          firstName
          lastName
          email
          dateOfBirth
          createdDate
          valid
          refunded
          cancelled
          reissued
          scanned
          ticketTypeName
          barcode
          ticketNumber
          ticketKey
          pdfDownloadUrl
          walletDownloadUrl
          onTicketMessage
          totalCost
          discount
          collectorTicket
          event {
            id
            name
            startDate
            digitalTicketsOnly
            client {
              id
            }
            images {
              items {
                id
                url
                type
                dimensions {
                  width
                  height
                  globalId
                }
              }
            }
            venue {
              id
              name
              address {
                locality
                region
              }
            }
          }
          ticketType {
            id
            name
            suppressDistribution
            paperTicketOnly
            collectorTicketCollectableOnly
          }
          order {
            id
            customer {
              firstName
              lastName
              email
            }
          }
          ticketAssign {
            assignedDate
            customer {
              id
              firstName
              lastName
            }
            revokedDate
          }
          resale {
            id
            offeredForSaleDate
            resalePrice
            status
            soldDate
            resaleFee
            clientResaleFee
          }
        }
      }
    }
  }
`;

export const GET_ORDERS_N_ASSIGNED_TICKETS_QUERY = gql`
  query getOrders($token: String) {
    viewer(token: $token) {
      assignedTickets: getTickets(pageIndex: 0, pageSize: 10, sortBy: ID, sortByDirection: DESC, assignedOnly: true) {
        items {
          id
          firstName
          lastName
          email
          dateOfBirth
          ticketTypeName
          collectorTicket
          # if there arent any orders, only assigned tickets
          event {
            id
            name
            client {
              id
            }
            startDate
            endDate
            description
            reissueFee
            peerToPeerResaleEnabled
            digitalTicketsOnly
            images {
              items {
                id
                url
                type
                dimensions {
                  width
                  height
                  globalId
                }
              }
            }
            resalePeriods {
              items {
                id
                ticketTypes(pageSize: 100) {
                  items {
                    ticketType {
                      id
                      name
                    }
                  }
                }
                startDate
                endDate
              }
            }
            venue {
              id
              name
              address {
                locality
                region
              }
            }
            ageRestriction
            ticketFinePrint
            ticketsRequireAttendeeName
            ticketsRequireAttendeeDob
          }
          ticketType {
            id
            name
            description
            complimentary
            suppressDistribution
            entryDate
            paperTicketOnly
              collectorTicketCollectableOnly
          }
          reissued
          refunded
          cancelled
          valid
          resale {
            id
            offeredForSaleDate
            resalePrice
            status
            soldDate
            resaleFee
            clientResaleFee
          }
          ticketReturn {
            id
            offeredForSaleDate
            soldDate
            status
            ticketReturnFee
            clientTicketReturnFee
          }
          pdfDownloadUrl
          walletDownloadUrl
          ticketNumber
          onTicketMessage
          totalCost
          discount
          barcode
          ticketKey
          ticketAssign {
            accessToken
            assignedDate
            customer {
              id
              firstName
              lastName
              email
            }
            revokedDate
          }
        }
      }
      orders: getOrders(pageIndex: 0, pageSize: 10, sortBy: ID, sortByDirection: DESC) {
        items {
          id
          channel
          createdDate
          customer {
            id
            firstName
            lastName
            email
            telephone
            mobile
          }
          event {
            id
            name
            client {
              id
            }
            startDate
            endDate
            description
            reissueFee
            peerToPeerResaleEnabled
            digitalTicketsOnly
            images {
              items {
                id
                url
                type
                dimensions {
                  width
                  height
                  globalId
                }
              }
            }
            resalePeriods {
              items {
                id
                ticketTypes(pageSize: 100) {
                  items {
                    ticketType {
                      id
                      name
                    }
                  }
                }
                startDate
                endDate
              }
            }
            venue {
              id
              name
              address {
                locality
                region
              }
            }
            ageRestriction
            ticketFinePrint
            ticketsRequireAttendeeName
            ticketsRequireAttendeeDob
          }
          tickets {
            items {
              id
              firstName
              lastName
              email
              dateOfBirth
              ticketTypeName
              collectorTicket
              event {
                id
                name
              }
              ticketType {
                id
                name
                description
                complimentary
                suppressDistribution
                entryDate
                paperTicketOnly
                collectorTicketCollectableOnly
              }
              reissued
              refunded
              cancelled
              valid
              resale {
                id
                offeredForSaleDate
                resalePrice
                status
                soldDate
                resaleFee
                clientResaleFee
              }
              ticketReturn {
                id
                offeredForSaleDate
                soldDate
                status
                ticketReturnFee
                clientTicketReturnFee
              }
              pdfDownloadUrl
              walletDownloadUrl
              ticketNumber
              onTicketMessage
              totalCost
              discount
              barcode
              ticketKey
              ticketAssign {
                accessToken
                assignedDate
                customer {
                  id
                }
                revokedDate
              }
            }
          }
        }
      }
    }
  }
`;
